import React, { useState, useEffect } from 'react';
import {
    Button, Card, CardHeader, Table, Container, Row, Col, Form, FormGroup, InputGroupAddon, InputGroupText, Input, InputGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, Badge,
} from "reactstrap";
import { Link } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { api } from '../../../../api';
import Cookies from 'js-cookie';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const Leave2 = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalAdd, setModalAdd] = useState(false);
    const toggleModalAdd = () => setModalAdd(prevState => !prevState);
    const [clientForm, setClientForm] = useState({});
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteProjectName, setDeleteProjectName] = useState('');
    const [dataToShow, setDataToShow] = useState([]);
    const [projectDropdownOpen1, setProjectDropdownOpen1] = useState(false);
    const [entriesToShow, setEntriesToShow] = useState(5);
    const [leaveData, setLeaveData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const emp_id = Cookies.get('emp_id');

    const toggleProjectDropdown1 = () => {
        setProjectDropdownOpen1(!projectDropdownOpen1);
    };

    const handleEntriesChange = (value) => {
        setEntriesToShow(value === 'All' ? leaveData.length : Number(value));
        setCurrentPage(1);
    };

    const statusOptions = [
        { "value": "Casual Leave", "label": "Casual Leave" },
        { "value": "Medical Leave", "label": "Medical Leave" },
        { "value": "Voting Leave", "label": "Voting Leave" },
        { "value": "Sabbatical Leave", "label": "Sabbatical Leave" },
        { "value": "Bereavement Leave", "label": "Bereavement Leave" },
        { "value": "Maternity Leave", "label": "Maternity Leave" },
        { "value": "Paternity Leave", "label": "Paternity Leave" },
        { "value": "Adoption Leave", "label": "Adoption Leave" },
        { "value": "Family Care Leave", "label": "Family Care Leave" },
        { "value": "Study Leave", "label": "Study Leave" },
        { "value": "Jury Duty Leave", "label": "Jury Duty Leave" },
        { "value": "Public Holiday Leave", "label": "Public Holiday Leave" },
        { "value": "Religious Holiday Leave", "label": "Religious Holiday Leave" }
    ];

    useEffect(() => {
        const fetchLeaveData = async () => {
            try {
                const company_id = Cookies.get('company_id');
                const response = await api.get(`leaveEmpDetails.php?emp_id=${emp_id}&company_id=${company_id}`);
                if (response.status === 200) {
                    // Sort data in descending order by applied_date (newest first)
                    const sortedData = response.data.sort((a, b) => {
                        const dateA = new Date(a.applied_date);
                        const dateB = new Date(b.applied_date);
                        return dateB - dateA; // Descending order (newest first)
                    });
                    
                    setLeaveData(sortedData);
                    setFilteredData(sortedData);
                    setDataToShow(sortedData.slice(0, entriesToShow));
                } else {
                    console.error("Failed to fetch leave data");
                }
            } catch (error) {
                console.error("Error fetching leave data:", error);
            }
        };
        fetchLeaveData();
    }, [emp_id, entriesToShow]);

    const handleDeleteConfirmation = async () => {
        try {
            const company_id = Cookies.get('company_id');
            const response = await api.get(`leaveEmpDetails.php?del_id=${deleteProjectName}&company_id=${company_id}`);
            console.log(response.data);
            window.location.reload();
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setShowDeleteConfirmation(false);
    };

    const [leave, setleave] = useState({
        emp_id: emp_id
    });

    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const validateForm = () => {
        const newErrors = {};
        
        if (!leave.leave_type || leave.leave_type.trim() === '') {
            newErrors.leave_type = 'Leave type is required';
        }
        
        if (!leave.Start_date || leave.Start_date.trim() === '') {
            newErrors.Start_date = 'Start date is required';
        }
        
        if (!leave.End_date || leave.End_date.trim() === '') {
            newErrors.End_date = 'End date is required';
        }
        
        if (!leave.description || leave.description.trim() === '') {
            newErrors.description = 'Leave description is required';
        }
        
        // Check if end date is after start date
        if (leave.Start_date && leave.End_date) {
            const startDate = new Date(leave.Start_date);
            const endDate = new Date(leave.End_date);
            if (endDate <= startDate) {
                newErrors.End_date = 'End date must be after start date';
            }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setleave(prevState => ({
            ...prevState,
            [name]: value
        }));
        
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleBlur = (fieldName) => {
        setTouched(prev => ({
            ...prev,
            [fieldName]: true
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        
        // Validate form before submission
        if (!validateForm()) {
            // Mark all fields as touched to show errors
            setTouched({
                leave_type: true,
                Start_date: true,
                End_date: true,
                description: true
            });
            return;
        }
        
        setIsSubmitting(true);
        
        try {
            const company_id = Cookies.get('company_id');
            if (!company_id) {
                alert('Company ID is missing. Please log in again.');
                return;
            }
            // Ensure company_id is included in the leave object
            const leaveWithCompany = { ...leave, company_id };
            const response = await api.post(`leavePM.php?company_id=${company_id}`, leaveWithCompany);
            console.log("Data sent successfully:", response.data);
            if (response.data && response.data.status === 'success') {
                setSuccessMessage('Leave applied successfully!');
                setShowSuccessAlert(true);
                setTimeout(() => {
                    setShowSuccessAlert(false);
                    window.location.reload();
                }, 1500);
            }
            // window.location.reload();
        } catch (error) {
            console.error("Error submitting data:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const totalPages = Math.ceil(filteredData.length / entriesToShow);

    const prePage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const getSerialNumber = (index) => {
        return (currentPage - 1) * entriesToShow + index + 1;
    };

    useEffect(() => {
        if (Array.isArray(filteredData)) {
            setDataToShow(filteredData.slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow));
        }
    }, [entriesToShow, currentPage, filteredData]);

    useEffect(() => {
        if (searchQuery.trim() === "") {
            setFilteredData(leaveData);
        } else {
            const filtered = leaveData.filter(item =>
                item.leave_type.toLowerCase().includes(searchQuery.toLowerCase())
            );
            // Maintain descending order for filtered results
            const sortedFiltered = filtered.sort((a, b) => {
                const dateA = new Date(a.applied_date);
                const dateB = new Date(b.applied_date);
                return dateB - dateA; // Descending order (newest first)
            });
            setFilteredData(sortedFiltered);
        }
        setCurrentPage(1);
    }, [searchQuery, leaveData]);

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Container fluid>
                    <Row className="mb-5">
  <Col xs="12">
    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center text-center text-lg-start">
      
      {/* Heading */}
      <h1 className="font-bold mb-3 mb-lg-0">Leave Management Table</h1>

      {/* Search Bar */}
      <Form className="navbar-search" style={{ width: '100%', maxWidth: '300px' }}>
        <FormGroup className="mb-0 w-100">
          <InputGroup
            className="input-group-alternative align-items-center"
            style={{ height: '40px' }}
          >
            <InputGroupAddon addonType="prepend">
              <InputGroupText className="border-right-0" style={{ height: '38px' }}>
                <i className="fas fa-search" style={{ color: 'black' }} />
                <Input
              placeholder="Search Leave Type"
              type="text"
              className="border-left-0 ml-2"
              style={{ height: '38px' }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
              </InputGroupText>
            </InputGroupAddon>
            
          </InputGroup>
        </FormGroup>
      </Form>

    </div>
  </Col>
</Row>


                    <Row className="mt-5">
                        <Col className="mb-5 mb-xl-0" xl="12">
                            <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0 font-bold">Leave List</h3>
                                            <div className="d-flex justify-content-end align-items-center">
                                                <div className="ml-6">
                                                    <Dropdown isOpen={projectDropdownOpen1} toggle={toggleProjectDropdown1}>
                                                        <DropdownToggle caret>
                                                            Show Entries: {entriesToShow === leaveData.length ? "All" : entriesToShow}
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                                                            <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                                                            <DropdownItem onClick={() => handleEntriesChange('All')}>All</DropdownItem>
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                </div>
                                                <div className='text-right'>
                                                    <Button
                                                        style={{
                                                            backgroundColor: '#d86f89',
                                                            borderColor: '#d86f89',
                                                            color: 'black',
                                                        }}
                                                        onClick={toggleModalAdd}
                                                    >
                                                        <span className="d-inline d-sm-none">Leave</span> {/* Mobile (xs only) */}
                                                        <span className="d-none d-sm-inline">Apply Leave</span> {/* Tablet & above */}
                                                    </Button>                                                
                                                    </div>
                                            </div>

                                        </div>
                                    </Row>
                                </CardHeader>

                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">SL.No</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Applied On</th>
                                            <th scope="col">Start Date</th>
                                            <th scope="col">End Date</th>
                                            <th scope="col">Current Status</th>
                                            <th scope="col">View</th>
                                            <th scope="col">Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dataToShow && Array.isArray(dataToShow) ? (
                                            dataToShow.map((item, index) => (
                                                <tr key={index}>
                                                    <th scope="row">{getSerialNumber(index)}</th>
                                                    <td>{item.leave_type}</td>
                                                    <td>{item.applied_date}</td>
                                                    <td>{item.start_date}</td>
                                                    <td>{item.end_date}</td>
                                                    <td>
                                                        <Badge
                                                            style={{
                                                                backgroundColor:
                                                                    item.status && item.status.toLowerCase() === 'approved'
                                                                        ? '#28a745' // green
                                                                        : item.status && item.status.toLowerCase() === 'rejected'
                                                                        ? '#dc3545' // red
                                                                        : '#F7D800', // yellow for pending/others
                                                                color: 'black',
                                                                minWidth: '100px',      // Ensures all badges are at least 100px wide
                                                                maxWidth: '120px',      // Optional: prevents overly wide badges
                                                                textAlign: 'center',
                                                                display: 'inline-block',
                                                                padding: '8px 0',
                                                                borderRadius: '8px',
                                                                fontWeight: 'bold',
                                                                letterSpacing: '1px'
                                                            }}
                                                            className="p-2"
                                                        >
                                                            {item.status}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        <Link to={`/site-admin/site-management/leavetable2/${item.id}`}>
                                                            <Tippy content="View Leave Details">
                                                                <i className="fa-solid fa-eye"></i>
                                                            </Tippy>
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <button onClick={() => { setDeleteProjectName(item.id); setShowDeleteConfirmation(true) }} className='btn btn-deeppink'>
                                                            <Tippy content="Delete Leave">
                                                                <i className="fa-solid fa-trash text-danger"></i>
                                                            </Tippy>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>

                                <nav className='mt-3'>
                                    <ul className='pagination justify-content-center'>
                                        <li className='page-item'>
                                            <a
                                                href='#'
                                                className='page-link text-primary'
                                                onClick={prePage}
                                                disabled={currentPage === 1}
                                            >
                                                Prev
                                            </a>
                                        </li>
                                        <li className='page-item'>
                                            <a
                                                href='#'
                                                className='page-link text-primary'
                                                onClick={nextPage}
                                                disabled={currentPage === totalPages}
                                            >
                                                Next
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modalAdd} toggle={toggleModalAdd}>
                <ModalHeader toggle={toggleModalAdd}>Add Leave</ModalHeader>
                <Form onSubmit={handleFormSubmit}>
                    <Row className='px-3'>

                        <Col md={12}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-status">Leave Type</label>
                                <Input
                                    className={`form-control-alternative ${errors.leave_type && touched.leave_type ? 'is-invalid' : ''}`}
                                    id="input-status"
                                    type="select"
                                    name="leave_type"
                                    onChange={handleInputChange}
                                    onBlur={() => handleBlur('leave_type')}
                                >
                                    <option value="">Select Leave Type</option>
                                    {statusOptions.map(option => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </Input>
                                {errors.leave_type && touched.leave_type && (
                                    <div className="invalid-feedback d-block">
                                        {errors.leave_type}
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-starting">Starting Date</label>
                                <Input
                                    className={`form-control-alternative ${errors.Start_date && touched.Start_date ? 'is-invalid' : ''}`}
                                    id="input-starting"
                                    type="date"
                                    name="Start_date"
                                    onChange={handleInputChange}
                                    onBlur={() => handleBlur('Start_date')}
                                />
                                {errors.Start_date && touched.Start_date && (
                                    <div className="invalid-feedback d-block">
                                        {errors.Start_date}
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-ending">Ending Date</label>
                                <Input
                                    className={`form-control-alternative ${errors.End_date && touched.End_date ? 'is-invalid' : ''}`}
                                    id="input-ending"
                                    type="date"
                                    name="End_date"
                                    onChange={handleInputChange}
                                    onBlur={() => handleBlur('End_date')}
                                />
                                {errors.End_date && touched.End_date && (
                                    <div className="invalid-feedback d-block">
                                        {errors.End_date}
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-description">Leave Description</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    onChange={(event, editor) => {
                                        const data = editor.getData().replace(/<[^>]*>/g, ''); // Remove HTML tags
                                        setleave(prevState => ({
                                            ...prevState,
                                            description: data
                                        }));
                                        
                                        // Clear error when user starts typing
                                        if (errors.description) {
                                            setErrors(prev => ({
                                                ...prev,
                                                description: ''
                                            }));
                                        }
                                    }}
                                    onBlur={() => handleBlur('description')}
                                />
                                {errors.description && touched.description && (
                                    <div className="invalid-feedback d-block">
                                        {errors.description}
                                    </div>
                                )}
                            </FormGroup>

                        </Col>
                    </Row>
                    <Row>
                        <Col lg='12' className='text-center mb-2'>
                            <Button 
                            style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} 
                            type="submit" 
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <i className="fas fa-spinner fa-spin mr-2"></i>
                                    Submitting...
                                </>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
            <Modal isOpen={showDeleteConfirmation} toggle={() => setShowDeleteConfirmation(false)}>
                <ModalHeader>Confirm Deletion</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete?
                </ModalBody>
                <div className="modal-footer">
                    <Button color="danger" onClick={handleDeleteConfirmation}>Yes</Button>
                    <Button color="secondary" onClick={() => setShowDeleteConfirmation(false)}>No</Button>
                </div>
            </Modal>
            {/* Success Alert Modal */}
            {showSuccessAlert && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                    justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
                }}>
                    <div style={{
                        backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                        maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
                    }}>
                        <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                        <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                        <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
                        <Button
                            style={{
                                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                                padding: '10px 25px', borderRadius: '25px'
                            }}
                            onClick={() => { setShowSuccessAlert(false); window.location.reload(); }}
                        >OK</Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Leave2;
